import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiLayout, FiDatabase, FiExternalLink } = FiIcons;

const AdminLayout = ({ children }) => {
  const location = useLocation();

  const navItems = [
    { name: 'Dashboard', path: '/admin', icon: FiLayout, end: true },
    { name: 'Property Structure', path: '/admin/structure', icon: FiDatabase },
  ];

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col md:flex-row">
      {/* Sidebar */}
      <aside className="w-full md:w-64 bg-slate-900 text-slate-300 md:min-h-screen shrink-0 flex flex-col shadow-xl z-10">
        <div className="p-6">
          <h2 className="text-white font-bold text-lg tracking-wide uppercase flex items-center gap-2">
            Admin Portal
          </h2>
          <p className="text-xs text-slate-500 mt-1">Temporary Access Enabled</p>
        </div>
        <nav className="flex-1 px-4 space-y-1">
          {navItems.map(item => {
            const isActive = item.end ? location.pathname === item.path : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.name}
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? 'bg-blue-600 text-white' : 'hover:bg-slate-800 hover:text-white'
                }`}
              >
                <SafeIcon icon={item.icon} className="w-5 h-5" />
                {item.name}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-slate-800">
          <Link to="/" className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-slate-400 hover:text-white transition-colors">
            <SafeIcon icon={FiExternalLink} />
            View Public Website
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-auto">
        <div className="max-w-6xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;